import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'antd';
import useApi from '../../hooks/useApi';
import { isEmpty } from '../../generalFunctions';
import YouTube from 'react-youtube';

const VideoGallary = () => {
    const [response, request] = useApi("/website/home/videos");
    const [videos, setVideos] = useState([]);

    useEffect(() => {
        request();
    }, []);//eslint-disable-line

    useEffect(() => {
        if (!isEmpty(response.data) && !response.error && !response.isLoading) {
            setVideos(response.data);
        }

    }, [response]);

    return (
        <Row gutter={[32, 32]}>
            {videos.map(video => <Col xl={12} lg={12} md={24} sm={24} xs={24} key={video.id}>
                <Card title={video.title}>
                    <YouTube
                        videoId={video.video_id}
                        id={video.id}
                        opts={{
                            height: "300",
                            width: "100%",
                            playerVars: {
                                rel: 0,
                            },
                        }}
                    />
                </Card>
            </Col>)}
        </Row>
    );
}

export default VideoGallary;